var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "toolbar" },
    [
      _c("ul", { staticClass: "toolbar-list" }, [
        _vm.showAlertMessages
          ? _c(
              "li",
              { staticClass: "toolbar-item" },
              [_c("AlertsContextMenuComponent")],
              1
            )
          : _vm._e(),
        _vm.showConfigPanel
          ? _c(
              "li",
              { staticClass: "toolbar-item" },
              [
                _c("ConfigPanelContextMenuComponent", {
                  attrs: {
                    showItem: _vm.showConfigPanelItem,
                    configurationUrl: _vm.configurationUrl,
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _c("span", { staticClass: "separator" }),
        _c(
          "li",
          { staticClass: "avatar-container" },
          [_c("AvatarContextMenuComponent")],
          1
        ),
        !_vm.isPortalUser
          ? _c(
              "li",
              {
                staticClass: "toolbar-item",
                on: { click: _vm.toggleSupportServiceDialog },
              },
              [_c("span", { class: [_vm.helpIcon, "icon-style"] })]
            )
          : _vm._e(),
        !_vm.isPortalUser
          ? _c(
              "li",
              { staticClass: "toolbar-item" },
              [_c("HubContextMenuComponent")],
              1
            )
          : _vm._e(),
      ]),
      _c("SupportServiceDialogComponent", {
        attrs: { showDialog: _vm.showSupportServiceDialog },
        on: { "hide-dialog": _vm.toggleSupportServiceDialog },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }